const useCheckForSubdomain = (subdomain: string): boolean => {
    if (typeof window === 'undefined') {
        return false
    }
    const hostname = new URL(window.location.href).hostname
    return hostname.startsWith(`${subdomain}.`)
}

export default useCheckForSubdomain
